import { render } from "./EWalletPage.vue?vue&type=template&id=0b7a1cde&ts=true"
import script from "./EWalletPage.vue?vue&type=script&lang=ts"
export * from "./EWalletPage.vue?vue&type=script&lang=ts"

import "./EWalletPage.vue?vue&type=style&index=0&id=0b7a1cde&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__